// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__naCQS","message":"Loader_message__dx6DO"};